import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note20',
  templateUrl: './note20.component.html',
  styleUrls: ['./note20.component.scss'],
})
export class Note20Component implements OnInit {
  note20Form: FormGroup;
  calculativeDate: any;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note20) {
        this.calculativeDate = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes18(data.response.userInputData.data);
        }
      }
    });
  }

  editNotes18(res): void {
    this.note20Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
    });
  }

  setForm(): void {
    this.note20Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
